const siteConfig = {
  brandName: "yorthmarketco",
  legalName: "ACK MARKETS LIMITED",
  logo: {
    type: "custom-mark",
    value: "YORTHMARKETCO",
  },
  description:
    "Independent everyday clothing shaped by useful proportions, tactile materials and thoughtful construction.",
  contact: {
    email: "logic@yorthmarketco.online",
    address: "Rm 701, Unit 108B, 7/F, Twr B New Mandarin Plaza, 14 Science Museum Rd, Tsim Sha Tsui, Hong Kong",
    addressLines: [
      "Rm 701, Unit 108B, 7/F,",
      "Twr B New Mandarin Plaza",
      "14 Science Museum Rd",
      "Tsim Sha Tsui",
      "Hong Kong",
    ],
  },
  currency: {
    code: "USD",
    locale: "en-US",
    symbol: "$",
  },
  shipping: {
    standard: 9.99,
  },
};

export const checkoutCountries = [
  "Australia",
  "Austria",
  "Belgium",
  "Canada",
  "China",
  "Denmark",
  "Finland",
  "France",
  "Germany",
  "Hong Kong",
  "Ireland",
  "Italy",
  "Japan",
  "Luxembourg",
  "Macao",
  "Malaysia",
  "Netherlands",
  "New Zealand",
  "Norway",
  "Portugal",
  "Singapore",
  "South Korea",
  "Spain",
  "Sweden",
  "Switzerland",
  "Taiwan",
  "Thailand",
  "United Kingdom",
  "United States",
];

export const formatPrice = (value) =>
  `${siteConfig.currency.symbol}${new Intl.NumberFormat(
    siteConfig.currency.locale,
    {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }
  ).format(Number(value))}`;

export default siteConfig;
